<!--
    @name: 单选框样式重写
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-12-10 15:54:13
-->
<template>
    <el-radio v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </el-radio>
</template>

<script>
export default {
  name: "ui-radio",
  inheritAttrs: false
}
</script>

<style scoped lang="scss">
/deep/.el-radio__input.is-checked .el-radio__inner{
  border-color:var(--Czsd);
  background: var(--FCfff);
  &:after{
    background-color:var(--Czsd);
  }
}
/deep/.el-radio__inner:hover{
  border-color:var(--Czsd);
}
/deep/.el-radio__input.is-checked+.el-radio__label{
  color:var(--Czsd);
}
</style>
